import is from 'typescript-styled-is'
import styled, { ITheme } from '../../theme'

const ExpandButton = styled.div`
  width: ${({ size }) => (size ? 24 * size : 24)}px;
  height: ${({ size }) => (size ? 24 * size : 24)}px;
  min-width: ${({ size }) => (size ? 24 * size : 24)}px;
  min-height: ${({ size }) => (size ? 24 * size : 24)}px;
  border-radius: 3px;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${is('disabled')`
		  background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
		pointer-events: none;
	`}

  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.slateGrey};
  }
`

export default ExpandButton

export interface IExpandButton {
  disabled?: boolean
}
